import {useSelector} from 'react-redux';

export const useHasAdminRights = () => {
  const user = useSelector(state => state.user);
  return user.isAdmin && !user.isSupport;
}

